var usePagination = function (currentPage, lastPage, type) {
    if (type === 'simple') {
        return [];
    }
    var situation = 'NONE';
    if (lastPage > 7) {
        if ((currentPage <= 4)) {
            situation = 'BEGINNING';
        }
        else if (lastPage - currentPage <= 3) {
            situation = 'END';
        }
        else if (currentPage > 4 || lastPage - currentPage > 3) {
            situation = 'MIDDLE';
        }
    }
    var temp = [];
    switch (situation) {
        case 'BEGINNING': {
            for (var i = 1; i <= 5; i++) {
                temp.push(i);
            }
            temp.push('...', lastPage);
            return temp;
        }
        case 'MIDDLE': {
            temp.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', lastPage);
            return temp;
        }
        case 'END': {
            for (var i = lastPage; i > (lastPage - 5); i--) {
                temp.push(i);
            }
            temp.push('...', 1);
            return temp.reverse();
        }
        default: {
            for (var i = 1; i <= lastPage; i++) {
                temp.push(i);
            }
            return temp;
        }
    }
};
export default usePagination;
//# sourceMappingURL=use-pagination.js.map